import { renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/svg/check-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-7760821e")

_pushScopeId("data-v-7760821e")
const _hoisted_1 = {
  key: 0,
  class: "relative",
  style: {"height":"0"}
}
const _hoisted_2 = { class: "flex flex-row w-full bg-white rounded-b-lg overflow-hidden" }
const _hoisted_3 = { class: "w-6 h-6 mx-2" }
const _hoisted_4 = {
  src: _imports_0,
  class: "w-full",
  alt: "check"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    id: "time-range-picker",
    class: ["flex flex-row relative w-auto", _ctx.customClass],
    style: `height: ${_ctx.onlyPanel ? '100%;' : '39px;'}`
  }, [
    (!_ctx.onlyPanel)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: 
        `flex flex-row items-center w-full relative ${
          _ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        }`
      ,
          style: {"height":"100%"},
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
        }, [
          _renderSlot(_ctx.$slots, "trigger", {}, () => [
            _createVNode("div", {
              class: ["flex flex-row align-middle items-center rounded-l-md text-black-lp-300 text-center border-r-0 border-gray-lp-400 border outline-none focus:shadow px-2.5", `${_ctx.customBackground || 'bg-gray-lp-700'} ${_ctx.customPaddingIcon}`],
              style: {"height":"100%"}
            }, [
              _createVNode("img", {
                src: require(`@/app/ui/assets/svg/${_ctx.customIcon || 'calendar'}.svg`),
                alt: "calendar"
              }, null, 8, ["src"])
            ], 2),
            _createVNode("div", {
              class: ["\n            flex align-middle items-center rounded-r-md px-2 text-sm font-light text-center w-full border-gray-lp-400 border\n          ", 
            `${_ctx.disabled ? 'text-gray-lp-600' : 'text-black-lp-300'} ${
              _ctx.isDateAlignCenter
                ? 'flex-col justify-center'
                : 'flex-row justify-between'
            } ${_ctx.customPaddingField}`
          ],
              style: {"height":"100%"}
            }, _toDisplayString(!_ctx.dates.start
              ? _ctx.$t(_ctx.placeholder)
              : `${_ctx.formatDateWithoutTime(
                  _ctx.dates.start
                )} - ${_ctx.formatDateWithoutTime(_ctx.dates.end)}`), 3)
          ], {}, true)
        ], 2))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: ["time-range-picker-content flex flex-col border border-gray-lp-400 rounded-lg bg-white", { 'absolute z-50': !_ctx.onlyPanel }],
      style: [
        `width: ${_ctx.onlyPanel ? '100%' : _ctx.advanceStyle.width}; ${
          _ctx.leftPosition ? 'left' : 'right'
        }: ${_ctx.positionX}px;`
      , {"box-shadow":"0 0 20px #e0e0e0"}],
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.dayFocusOut && _ctx.dayFocusOut(...args)))
    }, [
      (!_ctx.onlyPanel)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", {
              class: "triangle-up absolute",
              style: 
            `top:-20px; ${_ctx.leftPosition ? 'left' : 'right'}: ${
              _ctx.positionX < 0 ? 265 : 22
            }px;`
          
            }, null, 4)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.onlyPanel)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            class: 
          `text-center w-full py-3 ${_ctx.advanceStyle.fontSize} ${_ctx.advanceStyle.fontWeight} bg-white text-gray-lp-300 border-b-1 border-gray-lp-400 rounded-t-lg`
        
          }, _toDisplayString(_ctx.title || _ctx.$t("Rentang Waktu")), 3))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_2, [
        (!_ctx.hideOptions && !_ctx.onlyPanel)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: 
            `flex-grow ${_ctx.advanceStyle.fontSize} ${_ctx.advanceStyle.fontWeight} font-normal text-gray-lp-300 border-t border-gray-lp-400`
          
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                return _withDirectives((_openBlock(), _createBlock("div", {
                  key: index.toString(),
                  class: ["flex flex-row py-2 pr-2 items-center", 
              `${
                _ctx.isOptionDisabled
                  ? 'opacity-50 cursor-default'
                  : 'options cursor-pointer'
              } ${
                _ctx.isSelected(option) && _ctx.highlightOnSelected
                  ? 'bg-gray-lp-1000'
                  : 'bg-white'
              }`
            ],
                  onMousedown: 
              () => (!_ctx.isOptionDisabled ? _ctx.onSelectOptionList(option) : null)
            ,
                  ref: option
                }, [
                  _createVNode("div", _hoisted_3, [
                    _withDirectives(_createVNode("img", _hoisted_4, null, 512), [
                      [_vShow, _ctx.isSelected(option)]
                    ])
                  ]),
                  _createVNode("div", {
                    class: "capitalize text-left w-full",
                    onClick: ($event: any) => (_ctx.isCloseDateAfterSelect && index ? _ctx.onClickOutside() : null)
                  }, _toDisplayString(_ctx.convertOption(option)), 9, ["onClick"])
                ], 42, ["onMousedown"])), [
                  [_vShow, 
              (
                _ctx.showOptions ||
                `${_ctx.$t('custom')},${_ctx.$t('hari ini')},${_ctx.$t(
                  '7 hari terakhir'
                )},${_ctx.$t('30 hari terakhir')}`
              ).includes(option)
            ]
                ])
              }), 128))
            ], 2))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: "flex flex-col",
          style: `width: ${_ctx.hideOptions || _ctx.onlyPanel ? '100%' : '360px'}`,
          onMouseenter: _cache[3] || (_cache[3] = (e) => _ctx.onEnterCalendar(true)),
          onMouseleave: _cache[4] || (_cache[4] = (e) => _ctx.onEnterCalendar(false))
        }, [
          _createVNode(_component_DatePicker, {
            ref: "picker",
            modelValue: _ctx.dates,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => (_ctx.dates = $event)),
              _ctx.onDateSelected
            ],
            "is-range": _ctx.isRange,
            class: ["calendar-layout", `${_ctx.customCalendar ? '' : 'calendar'}`],
            attributes: _ctx.attributes,
            "min-date": _ctx.rangeDate.min,
            "max-date": _ctx.rangeDate.max,
            onDayclick: _ctx.dayClick,
            onDayfocusout: _ctx.dayFocusOut,
            "update-on-input": "",
            "from-page": _ctx.page
          }, null, 8, ["modelValue", "is-range", "class", "onUpdate:modelValue", "attributes", "min-date", "max-date", "onDayclick", "onDayfocusout", "from-page"]),
          _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
        ], 36)
      ])
    ], 6), [
      [_vShow, _ctx.showCalendar || _ctx.onlyPanel]
    ])
  ], 6)), [
    [_directive_click_outside, _ctx.onClickOutside]
  ])
})